import React, { useMemo } from "react";

import { Button } from "@app/scripts/react-general-components/Button";
import { Drawer } from "@app/scripts/react-general-components/Drawer";
import { useShopify } from "@app/scripts/react-hooks/shopify";
import { useLocaleContext } from "@app/scripts/react-providers/locales";
import { ProductStlProduct } from "@app/scripts/react-product-stl/components/ProductStlProduct";

import type { NormalisedProduct, Product } from "@app/scripts/types";

type Props = {
  products: Product[];
  headerImage: string;
  btnStyle?: "pin-title" | "default";
  btnColor?: "white" | "black" | "transparent";
};

export const ProductStl: React.FC<Props> = ({ products, headerImage, btnStyle, btnColor }) => {
  const { normaliseProduct } = useShopify();
  const { product } = useLocaleContext();

  const normalisedProducts: NormalisedProduct[] = useMemo(
    () => products?.map((product) => normaliseProduct(product)),
    [products]
  );

  const title = product?.shop_the_look || "Shop The Look";

  return (
    <Drawer
      heading={title}
      drawerClassName="product-stl__drawer"
      customButton={({ toggleOpen }) =>
        btnStyle === "pin-title" ? (
          <button onClick={toggleOpen} className={"button button--stl button--stl-" + btnColor} aria-label={title}>
            <div>
              <ui-icon width="16" height="16" name="icon-cart-small"></ui-icon>
              <span>{title}</span>
            </div>
          </button>
        ) : (
          <Button
            color={btnColor}
            variant="small"
            className="swiper-no-swiping product-stl__button"
            ariaLabel={title}
            onClick={toggleOpen}
            label={title}
          />
        )
      }
    >
      <div className="product-stl">
        <img className="product-stl__image" src={headerImage} />

        <div>
          {normalisedProducts?.map((product) => (
            <ProductStlProduct key={product.id} product={product} />
          ))}
        </div>
      </div>
    </Drawer>
  );
};
